import * as ActionType from "./dialog.type";


const initialState = {
    dialog:  false,
    type:  "",
    dialogData:  null,

};

export const dialogueReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionType.OPEN_DIALOGUE:
            // Correctly handle `{ data: null }` so it doesn't fall back to the entire payload object
            const dataToSet = (action.payload && 'data' in action.payload) ? action.payload.data : action.payload;
            return {
                ...state,
                dialog: true,
                type: action.payload?.type || "",
                dialogData: dataToSet || null,
            };
        case ActionType.CLOSE_DIALOGUE:
            return {
                ...state,
                dialog: false,
                type: "",
                dialogData: null,
            };




        default:
            return state;
    }
};
